module.exports = __webpack_public_path__ + "static/media/yourChoice.b06febf7.mp3";